import React from "react";
import JobForm from "job/components/JobForm";
import { grey } from "@mui/material/colors";
import Heading from "common/components/Heading";

const AddJob = () => {
  return (
    <>
      <div>
        <div>
          <Heading
            variant={"h3"}
            title={"New Job"}
            sxProp={{ fontWeight: 800, m: 2, p: 2, color: grey[600] }}
          />
        </div>
        <JobForm jobId="" />
      </div>
    </>
  );
};

export default AddJob;
